import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import {
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA,
} from "@angular/material/snack-bar";
import { AngularSvgIconModule } from "angular-svg-icon";
import { SnackbarNewData } from "./snackbar-new.models";

@Component({
  selector: "app-snackbar-new",
  templateUrl: "./snackbar-new.component.html",
  styleUrls: ["./snackbar-new.component.scss"],
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule],
})
export class SnackbarNewComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<SnackbarNewComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: SnackbarNewData
  ) {}

  onClose(): void {
    this.snackBarRef.dismiss();
  }
}
